import authRules from '../authRules.js';

const changeAssignmentsResource = (user) => {
  const { changeAssignmentsResource } = user.securityLevels;
  if (changeAssignmentsResource >= authRules.changeAssignmentsResource.changeAssignmentsResource) {
      return true;
  } else {
      return false;
    }
  }


export default changeAssignmentsResource;
